import { useEffect, useMemo } from 'react';
import Chapter from '../components/Blocks';
import FycHero, { fycHeroData } from './FycHero';
import Mark from '../components/Mark';
import PopupFrame from '../components/PopupFrame';
import { useSheet } from '../lib/sheets';
import { chaptersOf } from '../lib/parse';

/** A stand-alone page (EPK, FYC, GPJ, Trio) that shows one whole sheet. */
export default function SheetPage({ page }) {
  const { status, data } = useSheet(page.sheet);
  const chapters = useMemo(() => chaptersOf(data || []), [data]);
  const hero = useMemo(() => (page.hero === 'fyc' && data ? fycHeroData(chapters) : null), [page.hero, data, chapters]);

  useEffect(() => { document.title = `${page.title} | Ize Trio`; }, [page.title]);

  return (
    <>
      <header className="page-bar">
        <a className="nav-brand" href="/" aria-label="Ize Trio home"><Mark className="nav-mark" /><span>Ize Trio</span></a>
        <a className="btn btn--line" href="/">Back to the site</a>
      </header>
      <main className="doc">
        {!hero && <h1 className="sr-only">{page.title}</h1>}
        {hero && <FycHero data={hero} />}
        {status === 'loading' && <p className="doc-status">Loading…</p>}
        {status === 'error' && <p className="doc-status">This page can’t be loaded right now. Please try again later.</p>}
        {chapters.filter((c) => !hero || !hero.skip.has(c)).map((c, i) => <Chapter key={i} chapter={c} hide={hero && hero.hide} />)}
      </main>
      <PopupFrame />
    </>
  );
}
